import React from 'react';
import { Link } from 'react-router-dom';
import { AppFeature } from '../api/featuresApi';
import { useFeatures } from '../hooks/useFeatures';
import { useIsAdmin } from '../hooks/useIsAdmin';

interface FeatureRouteProps {
    feature: AppFeature;
    children: React.ReactNode;
}

/**
 * Renders a route only while its feature is on (Inställningar → Funktioner). Old links and
 * bookmarks to a feature that is off get a short notice instead of a silent redirect.
 */
const FeatureRoute = ({ feature, children }: FeatureRouteProps) => {
    const features = useFeatures();
    const isAdmin = useIsAdmin();

    if (!features) return null;
    if (features[feature]) return <>{children}</>;

    return (
        <div className="p-4" style={{ maxWidth: 600 }}>
            <h1 className="h4">Funktionen är avstängd</h1>
            <p className="text-muted">
                Den här delen av appen är avstängd för er organisation. Inget har tagits bort.
            </p>
            {isAdmin && <Link to="/settings/features">Gå till Inställningar › Funktioner</Link>}
        </div>
    );
};

export default FeatureRoute;
